import React from 'react';
import {connect} from 'react-redux';
import {Container, Dimmer, Loader, Button, Header, Breadcrumb} from 'semantic-ui-react';
import _ from 'lodash';
import {StackedBarChart} from 'go/pages/tracker/barChart';
import {AwardsTable} from 'go/pages/tracker/awardsTable';
import Workbook from 'vendor/react-excel-workbook';
import {DropDown} from 'go/pages/tracker/dropDown';
import {SortList} from 'go/pages/tracker/sortList';
import {TOTAL} from './constants';
import {showDollarAmountWithDollar, getPercentage} from 'common/utils';
import {HOME} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';
import {ENDPOINT_TRACKER} from 'common/endpoints';
import REST from 'go/requests/rest';
import {Link} from 'react-router-dom';
import {unpartitionedToggleIsOn} from 'common/storeUtils';
import goStore from 'go/store';

const ELIGIBILITY_AND_COMPLETENESS = "Eligibility and completeness";
const COMPETITIVE_MERIT_REVIEW = "Competitive merit review";
const PROGRAMMATIC_REVIEW = "Programmatic review";
const GRANTS_MANAGEMENT_REVIEW = "Grants management review";
const CONGRESSIONAL_NOTIFICATION = "Congressional notification";
const AWARD_SIGNATURE = "Award signature";
const ALLOCATION_PROCESSING = "Allocation processing";
const OBLIGATION_PROCESSING = "Obligation processing";
const PENDING_ACCEPTANCE = "Pending acceptance";
const ACCEPTED = "Accepted";
const NOT_AWARDED = "Not awarded";
const DECLINED_BY_RECIPIENT = "Declined by recipient";

const order = [ELIGIBILITY_AND_COMPLETENESS, COMPETITIVE_MERIT_REVIEW, PROGRAMMATIC_REVIEW, GRANTS_MANAGEMENT_REVIEW, 
                CONGRESSIONAL_NOTIFICATION, AWARD_SIGNATURE, ALLOCATION_PROCESSING, OBLIGATION_PROCESSING, PENDING_ACCEPTANCE,
                ACCEPTED, NOT_AWARDED, DECLINED_BY_RECIPIENT];

export class SetAside extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      column: 'rank',
      direction: 'ascending',
      filter: TOTAL,
      awards: [],
      loading: true,
      maxResults: 25,
      firstResult: 0,
      itemSummaries: [],
      targetChange: false,
      exportItems: [],
      attributes: [],
    };
  }

  UNSAFE_componentWillMount() {
    let {match} = this.props;

    const trackerId = match.params.trackerId;
    const targetId = match.params.targetId;
    const trackerName = match.params.name;
    this.setState({
      trackerName: trackerName,
      trackerId: trackerId,
      targetId: targetId,
    });
    this.getTarget(targetId);
    this.getTargets(trackerId);
  }

  updatePageTitle = (targetName) => {
    document.title = `${HOME} - ${targetName} Funding Target`;
  };

  fetchMoreData = () => {
    const {firstResult, maxResults, filter, targetId} = this.state;
    const trackerId = _.get(this.props, 'match.params.trackerId');

    const mileStoneArray = this.createMileStoneArray();

    let queryParams = {
      firstResult,
      maxResults,
    };

    if (filter != TOTAL) {
      _.set(queryParams, 'state', mileStoneArray[filter]);
    }

    // TODO remove OpenAPI toggle code (remove trackerId param)
    REST.tracker
      .getTrackerTargetItems(targetId, queryParams, trackerId)
      .then(REST.handler.handleResponse)
      .then((resJson) => {
        if (resJson) {
          const currentAwards = this.state.awards ? this.state.awards : [];

          this.setState({
            awards: currentAwards.concat(resJson),
            firstResult: this.state.firstResult + resJson.length,
            hasMore: resJson.length == this.state.maxResults,
          });
        }
      })
      .catch((error) => {
        console.error('error');
      });
  };

  getTarget = (targetId) => {
    this.setState({awards: [], firstResult: 0});
    const trackerId = _.get(this.props, 'match.params.trackerId');

    REST.tracker
      .getTrackerTargetById(trackerId, targetId)
      .then((response) => response.json())
      .then((resJson) => {
        if (resJson) {
          const targetName = resJson.targetName;
          this.setState({
            targetId: targetId,
            itemSummaries: resJson.itemSummaries,
            minTarget: resJson.minTarget,
            sum: resJson.sum,
            recommendedSum: resJson.recommendedSum,
            maxTarget: resJson.maxTarget,
            targetName: targetName,
            softTarget: resJson.softTarget,
          });
          this.updatePageTitle(targetName);
        }
      })
      .then(() => {
        this.fetchMoreData();
      })
      .catch((error) => {
        console.error('error');
      });
  };

  getTargets = (trackerId) => {
    REST.tracker
      .getTrackerById(trackerId)
      .then((response) => response.json())
      .then((resJson) => {
        if (resJson) {
          this.setState({
            setAsides: resJson.targets,
            loading: false,
            trackSubGrants: resJson.trackSubGrants,
            rankingDirection: resJson.rankingDirection,
            attributes: resJson.attributes.map((a) => a.attributeName),
          });
        }
      })
      .catch((error) => {
        console.error('error');
      });
  };

  exportExcel = () => {
    const {filter, targetId} = this.state;
    const mileStoneArray = this.createMileStoneArray();
    const trackerId = _.get(this.props, 'match.params.trackerId');

    let queryParams = {};
    if (filter != TOTAL) {
      _.set(queryParams, 'state', mileStoneArray[filter]);
    }

    // TODO remove OpenAPI toggle code (remove trackerId param)
    return REST.tracker
      .getTrackerTargetAllItems(targetId, queryParams, trackerId)
      .then(REST.handler.handleResponse)
      .then((resJson) => {
        return new Promise((resolve) =>
          this.setState({exportItems: resJson}, resolve(resJson))
        );
      });
  };

  createSummary = () => {
    var obj = {};
    var data = [];
    const items = this.orderItemSummaries();
    items.forEach((result, index) => {
      obj[index] = result.sum;
    });
    data[0] = obj;
    return data;
  };

  createMileStoneArray = () => {
    var mileStone = [];
    const items = this.orderItemSummaries();
    items.forEach((result, index) => {
      mileStone[index] = result.state;
    });
    return mileStone;
  };
  createMileStoneColorArray = () => {
    var mileStone = [];
    const items = this.orderItemSummaries();
    items.forEach((result, index) => {
      mileStone[index] = result.color;
    });
    return mileStone;
  };
  handleSortColumn = (result) => {
    this.setState({column: result});
  };

  handleSortDirection = (result) => {
    this.setState({direction: result});
  };

  handleFilterChange = (result) => {
    this.setState({filter: result, awards: [], firstResult: 0}, () => {
      this.fetchMoreData();
    });
  };

  orderItemSummaries = () => {
   const orderedItems = this.state.trackSubGrants ? _.sortBy(this.state.itemSummaries, (item) =>
    order.indexOf(item.state)
    ) : this.state.itemSummaries;
    return orderedItems;
  };

  render() {
    if (!this.state.loading) {
      const {
        setAsides,
        filter,
        awards,
        column,
        direction,
        targetName,
        sum,
        exportItems,
        trackerName,
        maxTarget,
        minTarget,
        softTarget,
        recommendedSum,
        trackSubGrants,
        attributes,
        rankingDirection,
      } = this.state;

      const mileStoneSummary = this.createSummary();
      const mileStoneArray = this.createMileStoneArray();
      const color = this.createMileStoneColorArray();
      const target = softTarget ? softTarget : minTarget ? minTarget : maxTarget;
      const recommended = recommendedSum;
      const recommendedPercent = getPercentage(recommended, target);
      const remaining = target - recommended;
      const remainingPercent = getPercentage(remaining, target);
      const workBook = (
        <Workbook
          filename={
            trackSubGrants ? 'SubawardRecommendations.xlsx' : 'AwardRecommendations.xlsx'
          }
          element={
            <a
              href="#"
              title="Export to Excel"
              onClick={(e) => {
                if (this.state.exportItems.length == 0) {
                  e.stopPropagation();
                  const target = e.target;
                  this.exportExcel()
                    .then((res) => {
                      target.click();
                    })
                    .then((res) => {
                      this.setState({exportItems: []});
                    });
                }
              }}
            >
              Export to Excel
            </a>
          }
        >
          <Workbook.Sheet data={exportItems} name="Sheet A">
            <Workbook.Column label="ID" value="key" />
            {_.includes(attributes, 'foTrackFundingTarget') && (
              <Workbook.Column label="Attribute" value="attribute" />
            )}
            {_.includes(attributes, 'organizationKind') && (
              <Workbook.Column
                label={trackSubGrants ? 'Suborganization Type' : 'Organization Type'}
                value="organizationInfo"
              />
            )}
            <Workbook.Column
              label={trackSubGrants ? 'Suborganization Name' : 'Organization Name'}
              value="organizationName"
            />
            <Workbook.Column label="State" value="orgState" />
            <Workbook.Column label="MileStone" value="state" />
            {!_.isEqual(rankingDirection, "NONE") && (<Workbook.column label="Cumulative score" value="score" />)}
            <Workbook.column label="Priority rank" value="rank" />
            <Workbook.column label="Fed share" value="value" />
          </Workbook.Sheet>
        </Workbook>
      );

      return (
        <React.Fragment>
          <React.Fragment>
            <Breadcrumb id="taskBreadcrumbs">
              <Breadcrumb.Section>
                <Link title="Tasks" to="/tasks">
                  Tasks
                </Link>
              </Breadcrumb.Section>
              <Breadcrumb.Divider />
              <Breadcrumb.Section>
                <Link title="Awards Tracker" to="/awardsTracker">
                  Awards Tracker
                </Link>
              </Breadcrumb.Section>
              <Breadcrumb.Divider />
              <Breadcrumb.Section active>{targetName} Funding Target</Breadcrumb.Section>
            </Breadcrumb>
            <div className="setAsideHeader">
              <Header as="h1" className="setAsideColumn">
                {targetName} Funding Target
              </Header>
            </div>
            <div className="setAsideHeader">
              <div className="setAsideDropDown" id="content">
                <DropDown
                  onTargetChange={this.getTarget}
                  setAsides={setAsides}
                  id="content"
                />
              </div>
            </div>
          </React.Fragment>

          <div className="setAsideHeader">
            <div className="setAsideColumn">
              {minTarget
                ? 'No less than ' + showDollarAmountWithDollar(target) + ' '
                : maxTarget
                ? 'No more than ' + showDollarAmountWithDollar(target) + ' '
                : showDollarAmountWithDollar(target) + ' '}
              | {showDollarAmountWithDollar(recommended) + ' '}
              recommended ({recommendedPercent}) |{' '}
              {showDollarAmountWithDollar(remaining) +
                ' remaining ' +
                remainingPercent +
                ' | '}
              {trackerName}
            </div>

            <Button basic floated="right" onClick={() => this.handleFilterChange(TOTAL)}>
              {trackSubGrants ? 'Show all subawards' : 'Show all awards'}
            </Button>
          </div>

          <StackedBarChart
            sum={sum}
            target={target}
            mileStoneSummary={mileStoneSummary}
            onFilterChange={this.handleFilterChange}
            mileStoneArray={mileStoneArray}
            color={color}
          />
          <h3 title="Award recommendations">
            {trackSubGrants ? 'Subaward recommendations' : 'Award recommendations'}
          </h3>
          <div className="setAsideHeader">
            <div className="setAsideColumn">
              Showing: {filter == TOTAL ? 'All' : mileStoneArray[filter]} | Total Fed
              Share:
              {filter == TOTAL
                ? showDollarAmountWithDollar(sum)
                : showDollarAmountWithDollar(mileStoneSummary[0][filter])}
            </div>

            <div className="setAsideColumn">
              <label>{'Sort by: '}</label>
            </div>
            <SortList
              onSortColumnChange={this.handleSortColumn}
              onSortDirectionChange={this.handleSortDirection}
              attributes={attributes}
              trackSubGrants={trackSubGrants}
            />

            <div className="setAsideColumn">{workBook}</div>
          </div>

          <AwardsTable
            awards={awards}
            hasMore={this.state.hasMore}
            fetchMoreData={this.fetchMoreData}
            filter={filter}
            mileStoneArray={mileStoneArray}
            column={column}
            direction={direction}
            trackSubGrants={trackSubGrants}
            rankingDirection={rankingDirection}
            attributes={this.state.attributes}
          />
        </React.Fragment>
      );
    }

    return (
      <Dimmer active inverted>
        <Loader inverted />
      </Dimmer>
    );
  }
}
